import React, { useState, useEffect } from 'react';
import { getCarePackageOrdersCookie, fetchOrder } from 'services/carePackage';

const STATUS_LABELS = {
    succeeded: 'Confirmed',
    pending: 'Processing',
    failed: 'Payment failed',
};

/**
 * Shows the viewer's previously purchased care packages for this event, with the
 * live order status fetched from the API — reassurance that the order was saved,
 * and a nudge against buying the same package twice by accident.
 */
const PastOrders = ({ eventId }) => {
    const savedOrders = getCarePackageOrdersCookie(eventId);
    const [orders, setOrders] = useState(savedOrders);

    useEffect(() => {
        if (!savedOrders.length) return;
        let cancelled = false;
        const loadStatuses = async () => {
            const withStatuses = await Promise.all(
                savedOrders.map(async order => {
                    try {
                        const { status } = await fetchOrder(order.orderNumber);
                        return { ...order, status };
                    } catch {
                        return order; // keep cookie data if the API is unreachable
                    }
                }),
            );
            if (!cancelled) setOrders(withStatuses);
        };
        loadStatuses();
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eventId]);

    if (!orders.length) return null;

    return (
        <div className="care-package-past-orders">
            <h4 className="care-package-past-orders-title">Your care packages</h4>
            <p className="care-package-past-orders-subtitle">
                You already sent the following to the family — thank you.
            </p>
            {orders.map(order => (
                <div className="care-package-past-order" key={order.orderNumber}>
                    <span className="care-package-past-order-product">{order.productName}</span>
                    <span className="care-package-past-order-number">Order {order.orderNumber}</span>
                    {order.status && (
                        <span className={`care-package-past-order-status ${order.status}`}>
                            {STATUS_LABELS[order.status] || order.status}
                        </span>
                    )}
                </div>
            ))}
        </div>
    );
};

export default PastOrders;
